









import { Component, Vue, Prop } from 'vue-property-decorator';

import Star from './components';

import { StringOrNumber } from '@/pages/profile/utils';
import IStars from './types';

@Component({
  components: {
    Star,
  },
})
export default class Stars extends Vue implements IStars {
  @Prop({ type: [String, Number], default: 0 })
  rating: StringOrNumber;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/review/components/stars/Stars.vue